import { type SelectionsMachine } from '../../../machine/selection-machine';
import { type ClickTarget } from '../utils/get-click-target';

export function dispatchInitialClick(
  machine: SelectionsMachine,
  target: ClickTarget,
  isShiftPressed = false
): void {
  const state = machine.getState();

  if (target.type === 'cell') {
    // Only extend if we're in cell mode and have a selection
    if (isShiftPressed && state.mode === 'cell' && state.selections.length === 1) {
      machine.dispatch({
        type: 'extendToCell',
        cell: target.position,
        source: 'mouse',
      });
    } else {
      // Treat as regular click when not in cell mode/no selection
      machine.dispatch({ type: 'selectCell', cell: target.position, source: 'mouse' });
    }
  } else if (target.type === 'row') {
    if (isShiftPressed && state.selections.length === 1) {
      machine.dispatch({
        type: 'extendToRow',
        row: target.row,
        source: 'mouse',
      });
    } else if (target.source === 'row-handle') {
      machine.dispatch({
        type: 'selectRows',
        ranges: [
          {
            anchor: {
              row: target.row,
              col: {
                index: 0,
              },
            },
            lead: {
              row: target.row,
              col: {
                index: 0,
              },
            },
          },
        ],
        source: 'mouse',
      });
    } else {
      // Row-checkbox uses toggleRow (adds/removes from selection)
      machine.dispatch({ type: 'toggleRow', row: target.row, source: 'mouse' });
    }
  } else if (target.type === 'column') {
    if (isShiftPressed && state.selections.length === 1) {
      machine.dispatch({
        type: 'extendToColumn',
        col: target.col,
        source: 'mouse',
      });
    } else {
      machine.dispatch({
        type: 'selectColumns',
        ranges: [
          {
            anchor: {
              col: target.col,
              row: {
                index: 0,
              },
            },
            lead: {
              col: target.col,
              row: {
                index: 0,
              },
            },
          },
        ],
        source: 'mouse',
      });
    }
  }
}
